module.exports = __webpack_public_path__ + "static/the-end-of-power-6cd9f0e41d4122c90f4b6ac1d474d580.jpg";